<template>
  <a-spin :spinning="spinning">
    <template #indicator>
      <Loading></Loading>
    </template>
    <div class="pc" v-if="orderDetails">
      <div class="pc-content-info">
        <div class="title-lang">
          <div>
            <template v-if="!orderDetails?.checkoutLogo">
              <div class="title">{{ $t('message.checkout.title') }}</div>
              <div class="description">{{ $t('message.checkout.description') }}</div>
            </template>
            <img v-else class="title-logo" :src="orderDetails?.checkoutLogo" alt="LOGO" />
          </div>
          <Lang></Lang>
        </div>
        <div class="methods">
          <a-form-model-item
            :style="{ display: isDisplayPaymentCountry ? 'block' : 'none' }"
            :label="$t('message.checkout.country')"
            prop="paymentCountry"
          >
            <CountrySelect
              ref="countrySelect"
              :form="form"
              key-code="paymentCountry"
              :on-focus="onItemFocus"
              :on-blur="onItemBlur"
              :on-change="onCountryChange"
              :is-disable="+orderDetails?.editorialDisplay === 1 && !!this.orderDetails?.billing?.country"
            ></CountrySelect>
          </a-form-model-item>
          <template
            v-if="
              canSelectMethods &&
              canSelectMethods.length > 0 &&
              !(canSelectMethods.length === 1 && topMethods[0].code === 'CARD')
            "
          >
            <div class="method-title">
              {{ $t('message.checkout.recommendation') }}
            </div>
            <div class="items">
              <div
                @click="chooseMethod(topMethodsIndex[index])"
                class="item"
                v-for="(item, index) in topMethods"
                :key="index"
                :class="{
                  active: topMethodsIndex[index] === chosenPaymentMethodIndex
                }"
              >
                <img :src="displayCardIcon(item)" />
                <div class="name">{{ item?.cardName }}</div>
              </div>
              <div v-if="canSelectMethods && canSelectMethods.length > 3" class="more" @click="viewAllMethod"></div>
            </div>
          </template>
          <div v-if="!canSelectMethods || canSelectMethods.length <= 0" class="description error-tips">
            {{ $t('message.checkout.methodErrorTips') }}
          </div>
        </div>
        <div v-if="chosenPaymentMethod" class="warn-tips">{{ chosenPaymentMethod?.hint }}</div>
        <FormContent ref="formContent" :order-details="orderDetails" :chosen-payment-method="chosenPaymentMethod">
        </FormContent>
        <div>
          <div class="error-tips" v-if="resultTips">{{ resultTips }}</div>
          <template v-if="!viewMorePaymentMethod && !loading">
            <ApplePay
              v-if="getCheckSupportResults(chosenPaymentMethod, true, APPLE_PAY)"
              :order="orderDetails"
              :set-error-tips="setErrorTips"
              :get-from-data="getCurrentFormData"
              @loading="setLoadingValue"
            >
            </ApplePay>
            <GooglePay
              v-else-if="getCheckSupportResults(chosenPaymentMethod, true, GOOGLE_PAY)"
              :order="orderDetails"
              :get-from-data="getCurrentFormData"
              :set-error-tips="setErrorTips"
              @loading="setLoadingValue"
            >
            </GooglePay>
            <StripeButton
              v-else-if="getCheckSupportResults(chosenPaymentMethod, false, APPLE_PAY)"
              :order="orderDetails"
              :button-type="APPLE_PAY"
              :tips-function="setErrorTips"
            >
            </StripeButton>
            <StripeButton
              v-else-if="getCheckSupportResults(chosenPaymentMethod, false, GOOGLE_PAY)"
              :order="orderDetails"
              :button-type="GOOGLE_PAY"
              :tips-function="setErrorTips"
            ></StripeButton>
            <StripeButton
              v-else-if="!!orderDetails?.sp && chosenPaymentMethod?.code === CRYPTO_PAY"
              :order="orderDetails"
              :button-type="CRYPTO_PAY"
              :tips-function="setErrorTips"
            >
            </StripeButton>
            <a-button
              v-else-if="orderDetails?.subscription"
              class="button"
              type="primary"
              :size="size"
              @click="submit"
              :disabled="radarLoading || disable"
            >
              <!-- :disabled="!agreementChecked" -->
              <a-icon type="lock" theme="filled" />
              <span>{{ orderDetails.amount }} {{ $t('message.checkout.subscribePay') }}</span>
            </a-button>
            <a-button v-else class="button" type="primary" :size="size" @click="submit" :disabled="radarLoading || disable">
              <a-icon type="lock" theme="filled" />
              <span>{{ orderDetails.amount }} {{ $t('message.checkout.pay') }}</span>
            </a-button>
          </template>
          <!-- <div class="agreement-container" v-if="orderDetails?.subscription">
            <input type="checkbox" id="agreement" v-model="agreementChecked" class="agreement-checkbox" />
            <label for="agreement" class="agreement-label">
              <div class="read-agreement" v-html="$t('message.checkout.readAgreement')" @click="handleProtocolClick"></div>
            </label>
          </div> -->
          <a-button v-if="orderDetails.cancelUrl" @click="cancel" class="return-link" type="link"
            >{{ $t('message.checkout.returnToMerchant') }}
          </a-button>
        </div>
      </div>
      <div class="order-info">
        <div class="products Subscribe">
          <div v-if="orderDetails?.subscription">
            <div class="item">
              <span class="text amount">{{ orderDetails.amount }} {{ orderDetails.currency }}</span>
              <span class="text month">{{ getSubscriptionCycleText(orderDetails.subscriptionCycle) }}</span>
            </div>
            <div
              class="tip"
              v-html="
                $t('message.subscribe.renewTip', {
                  date: getSubscriptionCycleText(orderDetails.subscriptionCycle),
                  amount: orderDetails.amount,
                  currency: orderDetails.currency
                })
              "
            ></div>
          </div>
          <div v-else>
            <div>
              <span class="label">{{ $t('message.checkout.orderId') }}: </span>
              <span class="content">{{ orderDetails.uniqueId }}</span>
            </div>
            <div class="products-list">
              <div class="product-item" v-for="(product, pIndex) in orderDetails.products" :key="pIndex">
                {{ product.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="amount-info">
          <div v-if="!orderDetails?.subscription">
            <div class="item">
              <span class="label">{{ $t('message.checkout.orderAmount') }}</span>
              <span class="text amount">{{ orderDetails.amount }} {{ orderDetails.currency }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.billingDescriptor') }}</span>
              <span class="text">{{ orderDetails.billingDescription }}</span>
            </div>
          </div>
          <div v-else>
            <div class="item">
              <span class="label">{{ $t('message.checkout.product') }}</span>
              <span class="text" :title="orderDetails.products[0].name">{{ orderDetails.products[0].name }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.subscribeType') }}</span>
              <span class="text">{{ getSubscriptionTypeText(orderDetails.subscriptionType) }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.renewCycle') }}</span>
              <span class="text">{{ getSubscriptionCycleText(orderDetails.subscriptionCycle) }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.renewAmount') }}</span>
              <span class="text">{{ orderDetails.amount }} {{ orderDetails.currency }}</span>
            </div>
          </div>
        </div>
        <div class="countdown">
          <div class="tip">{{ $t('message.checkout.timeLimit') }}</div>
          <div class="time">{{ initSecondDisplay(Math.floor(countdown / 60)) }} : {{ initSecondDisplay(countdown % 60) }}</div>
        </div>
      </div>
    </div>
    <a-modal
      v-model="viewMorePaymentMethod"
      :title="$t('message.checkout.choosePaymentMethod')"
      :dialogClass="'checkout-dialog'"
      @ok="handleOk"
    >
      <div class="items" v-if="canSelectMethods && canSelectMethods.length > 0">
        <div
          v-for="(method, methodIndex) in canSelectMethods"
          :key="methodIndex"
          class="item"
          @click="selectMethod(methodIndex)"
          :class="{ active: activePaymentMethodIndex === methodIndex }"
        >
          <img class="method-img" :src="displayCardIcon(method)" />
          <span class="method-name">{{ method?.cardName }}</span>
        </div>
      </div>
      <template slot="footer">
        <div class="buttons">
          <a-button key="back" type="link" @click="handleCancel" :size="size">
            {{ $t('message.checkout.later') }}
          </a-button>
          <a-button key="submit" type="primary" :loading="loading" :size="size" @click="handleOk">
            {{ $t('message.checkout.continue') }}
          </a-button>
        </div>
      </template>
    </a-modal>

    <!-- 协议组件 -->
    <!-- <Protocol v-model="protocolVisible" /> -->
  </a-spin>
</template>
<script>
import { mapGetters } from 'vuex'
import FormContent from '@/views/checkout/payment/components/form-content/index.vue'
import CountrySelect from '@/views/checkout/payment/components/form-content/country/index.vue'
import Loading from '@/components/loading'
import { confirm } from '@/views/checkout/api'
import Lang from '@/components/lang/index.vue'
import {
  initCanUseMethod,
  initCountryOptions,
  initSecondDisplay,
  isShowEmoji,
  toTransactionResult,
  initTopMethodList,
  displayCardIcon,
  checkSupportResults
} from '@/views/checkout/tools'
import { saveExecuteTime, submitOperationData } from '@/views/checkout/tools/collect'
import GooglePay from '@/views/checkout/payment/components/google-pay/index.vue'
import ApplePay from '@/views/checkout/payment/components/apple-pay/index.vue'
import StripeButton from '@/views/checkout/payment/components/stripe/index.vue'
import { loadScript } from '@/views/checkout/tools/utils'
// import Protocol from '@/components/protocol/index.vue'
import { APPLE_PAY, CRYPTO_PAY, GOOGLE_PAY } from '@/enums/methods'

export default {
  components: {
    FormContent,
    CountrySelect,
    Loading,
    Lang,
    StripeButton,
    ApplePay,
    GooglePay
    // Protocol
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['app'])
  },
  data() {
    return {
      APPLE_PAY,
      GOOGLE_PAY,
      CRYPTO_PAY,
      isDisplayPaymentCountry: true,
      orderDetails: this.$props.order,
      canSelectMethods: [],
      topMethods: [],
      topMethodsIndex: [],
      size: 'large',
      viewMorePaymentMethod: false,
      chosenPaymentMethod: null,
      chosenPaymentMethodIndex: 0,
      activePaymentMethodIndex: 0,
      spinning: false,
      loading: false,
      disable: false,
      radarLoading: true,
      form: {
        paymentCountry: ''
      },
      countdown: 0,
      orderId: this.$route.params.id,
      // 接口返回的提示信息
      resultTips: '',
      agreementChecked: false,
      protocolVisible: false,
      // Radar Session
      radarSessionData: null
    }
  },
  async created() {
    try {
      this.initCountryList()
      this.chosenPaymentMethod = this.canSelectMethods[this.chosenPaymentMethodIndex]
      await this.initRadarSession()
    } catch (error) {
      console.error(error)
    }
  },
  mounted() {
    saveExecuteTime('startTime', window.initPage)
    saveExecuteTime('completedTime')
  },
  methods: {
    initSecondDisplay,
    isShowEmoji,
    displayCardIcon,
    getSubscriptionCycleText(cycle) {
      const cycleMap = {
        0: this.$t('message.subscribe.weekly'),
        1: this.$t('message.subscribe.monthly'),
        2: this.$t('message.subscribe.quarterly'),
        3: this.$t('message.subscribe.semiAnnually'),
        4: this.$t('message.subscribe.annually'),
        5: this.$t('message.subscribe.daily'),
        6: this.$t('message.subscribe.eachCalendarMonth')
      }
      return cycleMap[cycle] || cycle
    },
    getSubscriptionTypeText(type) {
      const typeMap = {
        0: this.$t('message.subscribe.regularRenewal'),
        1: this.$t('message.subscribe.oneTime')
      }
      return typeMap[type] || type
    },
    setErrorTips(message) {
      this.resultTips = message
    },
    setLoadingValue(value) {
      this.spinning = value
    },
    initTopMethods() {
      initTopMethodList(this)
    },
    initCountryList() {
      initCountryOptions(this.orderDetails, this.form, (allCountry, localCountry) => {
        this.isDisplayPaymentCountry =
          (allCountry?.length > 1 || (this.orderDetails?.paymentLogos?.length > 1 && localCountry?.length > 1)) &&
          (+this.orderDetails?.editorialDisplay !== 2 || !this.orderDetails?.billing?.country)
        this.$nextTick(() => {
          this.$refs.countrySelect.setAllData(allCountry, localCountry)
          this.onCountryChange(this.form.paymentCountry)
          this.$refs.formContent.setAllData(allCountry, localCountry)
        })
      })
    },
    onItemFocus() {
      this.$refs.formContent.onItemFocus()
    },
    onItemBlur(code, value, type) {
      this.$refs.formContent.onItemBlur(code, value, type)
    },
    onCountryChange(country) {
      this.canSelectMethods = initCanUseMethod(this, country)
      this.initTopMethods()
      this.$refs.formContent.setFormData('country', country)
    },
    setCountdown(countdown) {
      this.countdown = countdown
    },
    getCurrentFormData() {
      return this.$refs.formContent.getFormData()
    },
    getCheckSupportResults(cardInfo, isOur, paymentMethod) {
      return checkSupportResults(this, cardInfo, isOur, paymentMethod)
    },
    async initRadarSession() {
      if (!this.orderDetails?.sp) {
        this.radarLoading = false
        return
      }
      const { paymentUrl, appId } = this.orderDetails || {}
      const gateway = new URL(paymentUrl).origin || ''

      if (!gateway || !appId) {
        this.radarLoading = false
        console.log('⚠️ No gateway or appId found, skipping Radar session')
        return
      }
      loadScript(`${gateway}/script/js-radar-sdk.min.umd.cjs`)
        .then(async () => {
          this.radarSessionData = await JsRadar.createRadar({ gateway, appId: String(appId) })
        })
        .finally(() => {
          this.radarLoading = false
        })
    },
    submit() {
      saveExecuteTime('subTime')
      this.$refs.formContent.verificationForm(async (submitData) => {
        if (submitData) {
          this.spinning = true
          try {
            if (this.radarSessionData && submitData.extension) {
              submitData.extension.radarSession = JSON.stringify(this.radarSessionData)
            }

            const res = await confirm(this.orderId, submitData)
            toTransactionResult(this, res, this.orderId)
            this.spinning = false
            submitOperationData()
          } catch (error) {
            submitOperationData()
            this.spinning = false
            this.$router.push({
              name: 'CheckoutFailed',
              params: { id: this.orderId }
            })
            console.error('confirm error', error)
          }
        }
      })
    },
    cancel() {
      window.location.href = this.orderDetails.cancelUrl
    },
    viewAllMethod() {
      this.activePaymentMethodIndex = this.chosenPaymentMethodIndex
      this.viewMorePaymentMethod = true
    },
    selectMethod(index) {
      this.activePaymentMethodIndex = index
    },
    chooseMethod(index) {
      this.chosenPaymentMethodIndex = index
      this.activePaymentMethodIndex = index
      // 选中的是Method支付方式
      this.chosenPaymentMethod = this.canSelectMethods[this.chosenPaymentMethodIndex]
      this.loading = true
      this.$nextTick(() => {
        this.loading = false
      })
    },
    handleOk() {
      this.chosenPaymentMethodIndex = this.activePaymentMethodIndex
      this.chosenPaymentMethod = this.canSelectMethods[this.chosenPaymentMethodIndex]
      if (this.topMethodsIndex.indexOf(this.activePaymentMethodIndex) < 0) {
        this.topMethodsIndex[this.topMethodsIndex.length - 1] = this.activePaymentMethodIndex
        this.topMethods[this.topMethods.length - 1] = this.canSelectMethods[this.activePaymentMethodIndex]
      }
      this.viewMorePaymentMethod = false
    },
    handleCancel() {
      this.viewMorePaymentMethod = false
    },
    handleProtocolClick(event) {
      const protocolLink = event.target.closest('.protocol-link')
      if (protocolLink) {
        event.preventDefault()
        event.stopPropagation()
        this.protocolVisible = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';
@import '~@/views/checkout/styles/index.less';
@import '~@/styles/custom.less';

.pc {
  display: flex;
  justify-content: space-between;
  max-width: 900px;
  margin: 0 auto;
  padding-top: 67px;
  flex-wrap: wrap;

  .warn-tips {
    color: @warn-color;
    margin-top: -10px;
    margin-bottom: 15px;
  }

  .pc-content-info {
    background-color: @white;
    width: 540px;
    padding: 35px 40px;

    .title {
      #Font.heavy();
      font-size: 20px;
      line-height: 27px;
    }

    .description {
      font-size: 14px;
      line-height: 19px;
      margin-top: 10px;
    }

    .title-lang {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
    }

    .title-logo {
      max-width: 420px;
      max-height: 60px;
      object-fit: cover;
    }
  }

  .button {
    width: 100%;
    #Font.heavy();
    .pay-button();
    background-color: @checkout-hight-text-color;

    &:disabled {
      background-color: #cccccc;
      color: #999999;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;

      &:hover {
        transform: none;
        box-shadow: none;
      }
    }
  }

  .return-link {
    padding: 0;
    #Font.regular();
    font-size: 14px;
    margin-top: 20px;
  }

  .agreement-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 16px 0;
    max-width: 100%;

    .agreement-checkbox {
      margin-right: 8px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      appearance: none;
      border: 1px solid #d9d9d9;
      outline: none;
      cursor: pointer;
      position: relative;
      margin-top: 2px;

      &:checked {
        background-color: @checkout-hight-text-color;
        border-color: @checkout-hight-text-color;

        &:after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: white;
        }
      }
    }

    .agreement-label {
      cursor: pointer;
      max-width: 80%;

      .read-agreement {
        font-size: 14px;
        line-height: 19px;
        #Font.regular();
        word-wrap: break-word;
        white-space: normal;
        text-align: left;
      }
    }
  }

  .order-info {
    background-color: @white;
    width: 345px;
    padding: 10px 10px 32px;
    height: fit-content;

    .products {
      background: @checkout-bg;
      padding: 12px;

      .label {
        #Font.regular();
        font-size: 14px;
        line-height: 19px;
      }

      .content {
        #Font.heavy();
        font-size: 14px;
        line-height: 19px;
      }

      .products-list {
        margin-top: 15px;

        .products-item {
          #Font.regular();
          font-size: 14px;
          line-height: 19px;
        }
      }
    }
    .Subscribe {
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 0;

        .text {
          #Font.heavy();
          font-size: 14px;
          line-height: 19px;

          &.amount {
            font-size: 18px;
            line-height: 25px;
            color: @checkout-hight-text-color;
          }

          &.month {
            font-size: 18px;
            line-height: 25px;
          }
        }
      }
    }
    .amount-info {
      padding: 18px 12px 33px;

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 0;

        .label {
          #Font.regular();
          font-size: 14px;
          line-height: 19px;
        }

        .text {
          #Font.heavy();
          font-size: 14px;
          line-height: 19px;
          max-width: 60%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.amount {
            font-size: 18px;
            line-height: 25px;
            color: @checkout-hight-text-color;
            max-width: 60%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .countdown {
      padding: 0 12px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 25px;

      .tip {
        #Font.regular();
        font-size: 14px;
        line-height: 19px;
      }

      .time {
        background: @checkout-bg;
        width: 75px;
        min-width: 75px;
        height: 34px;
        line-height: 34px;
        #Font.heavy();
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
        margin-top: 4px;
      }
    }
  }
}

.checkout-dialog {
  .items {
    .item {
      border-radius: 4px;
      height: 65px;
      display: flex;
      margin-top: 7px;
      align-items: center;
      padding: 0 12px;
      cursor: pointer;

      &:first-child {
        margin-top: 0;
      }

      &.active {
        background: @checkout-bg;
      }

      .method-img {
        width: 50px;
        max-height: 33.5px;
        margin-right: 28px;
      }

      .method-name {
        #Font.heavy();
        font-size: 18px;
        line-height: 25px;
        color: @checkout-text-color;
      }
    }
  }
}
</style>
